"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _location = _interopRequireDefault(require("./location"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _propTypes.default.shape({
  alias: _propTypes.default.string,
  description: _propTypes.default.string,
  type: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  headquarterLocation: _location.default,
  additionalLocations: _propTypes.default.arrayOf(_location.default),
  active: _propTypes.default.bool,
  totalQualifiedFor: _propTypes.default.number,
  urlAddress: _propTypes.default.string,
  numberOfEmployees: _propTypes.default.number,
  industries: _propTypes.default.arrayOf(_propTypes.default.shape({
    industry: _propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string,
      parent_id: _propTypes.default.number
    }),
    vertical: _propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string,
      parent_id: _propTypes.default.number
    })
  })),
  jobFunctions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string
  })),
  internalDivisions: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    url: _propTypes.default.string,
    industryId: _propTypes.default.number,
    industry: _propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string
    })
  })),
  subsidiaries: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    url: _propTypes.default.string,
    industryId: _propTypes.default.number,
    verticalIndustryId: _propTypes.default.number,
    industry: _propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string
    }),
    verticalIndustry: _propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string
    })
  })),
  overallShortStatement: _propTypes.default.string,
  emojis: _propTypes.default.string,
  socialMedias: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    social: _propTypes.default.number,
    title: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  pointOfContact: _propTypes.default.shape({
    stateCode: _propTypes.default.string,
    cityId: _propTypes.default.string,
    countryId: _propTypes.default.number,
    international: _propTypes.default.bool,
    cityName: _propTypes.default.string,
    countryName: _propTypes.default.string,
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    phone: _propTypes.default.string,
    address: _propTypes.default.string,
    email: _propTypes.default.string,
    companyEmailDomain: _propTypes.default.string,
    state: _propTypes.default.shape({
      name: _propTypes.default.string,
      state_code: _propTypes.default.string
    }),
    city: _propTypes.default.shape({
      id: _propTypes.default.number,
      city: _propTypes.default.string,
      state_code: _propTypes.default.string
    }),
    postalCode: _propTypes.default.string
  }),
  aggregateDataHive: _propTypes.default.bool,
  cultureImageUrl: _propTypes.default.string,
  cultureImageName: _propTypes.default.string,
  cultureCaption: _propTypes.default.string,
  culture: _propTypes.default.string,
  mission: _propTypes.default.string,
  missionLink: _propTypes.default.string,
  diversityMean: _propTypes.default.string,
  diversityMeanLink: _propTypes.default.string,
  coreValues: _propTypes.default.string,
  hiveCulturalKeywords: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string
  })),
  socialImpact: _propTypes.default.string,
  socialImpactLink: _propTypes.default.string,
  talentGuide: _propTypes.default.string,
  talentGuideLink: _propTypes.default.string,
  undergraduate: _propTypes.default.string,
  undergraduateLink: _propTypes.default.string,
  recruit: _propTypes.default.string,
  careerRunways: _propTypes.default.string,
  interviewStyles: _propTypes.default.string,
  internships: _propTypes.default.string,
  welcomeImageFileName: _propTypes.default.string,
  welcomeImageUrl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  welcomeCaption: _propTypes.default.string,
  welcome: _propTypes.default.string,
  videos: _propTypes.default.arrayOf(_propTypes.default.shape({
    fileName: _propTypes.default.string,
    title: _propTypes.default.string,
    caption: _propTypes.default.string,
    id: _propTypes.default.number,
    previewUrl: _propTypes.default.string,
    toDelete: _propTypes.default.bool
  })),
  influencers: _propTypes.default.arrayOf(_propTypes.default.shape({
    handle: _propTypes.default.string,
    name: _propTypes.default.string,
    url: _propTypes.default.string,
    socialNetwork: _propTypes.default.number
  })),
  recentPress: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string,
    title: _propTypes.default.string
  })),
  recentCommitments: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  logoUrl: _propTypes.default.string,
  name: _propTypes.default.string,
  photoUrl: _propTypes.default.string,
  profileComplete: _propTypes.default.bool,
  newWelcomeImageUploaded: _propTypes.default.bool
});
exports.default = _default;